import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {Member, MemberInitState, StarTransactionAVG,} from '@/store/member/member.types';
import {ServiceInitState} from '@/store/service/service.types';
import {Toast} from '@/store/toast/toast.types';
import StarRatingComponent from '@/components/profile/StarRating.vue';
import BoxTextComponent from '@/components/profile/BoxText.vue';
import {MemberServiceType} from '@/store/member/member.enum';
import {FileType, ReferenceID} from '@/store/files/files.types';
import {Branch} from '@/store/branch/branch.types';
import {Community, CommunityInitState, FilterCommunity} from '@/store/community/community.types';

@Component({
  components: {
    BoxTextComponent,
    StarRatingComponent
  }
})
export default class VisitViewComponent extends Vue {
  @State('member') memberInitState!: MemberInitState;
  @State('service') serviceState!: ServiceInitState;
  @State('community') communityInitState!: CommunityInitState;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => void;
  @Action('_getMemberById', {namespace: 'member'}) getMemberById!: (payload: string) => Promise<void>;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_getTimeVisitorInformationById', {namespace: 'member'}) getTimeVisitorInformationById!: (id: string) => Promise<string>;
  @Action('_getStarByMemberId', {namespace: 'member'}) getStarByMemberId!: (id: string) => Promise<string>;
  @Action('_getFiles', {namespace: 'file'}) getFiles!: (payload: ReferenceID) => Promise<any>;
  @Action('_getByBranchId', {namespace: 'branch'}) getByBranchId!: (payload: string) => Promise<Branch>;
  @Action('_getCommunityForRegister', {namespace: 'community'}) getCommunityForRegister!: (payload: FilterCommunity) => Promise<void>;

  public member = {} as Member;
  public branch = {} as Branch;
  public timeInformation = '0';
  public memberId!: string;
  public strRdy: boolean = false;
  public image = '';
  public community = {communityName: 'ไม่มี'} as Community;
  public communityList = [{id: ''}] as Community[];

  async mounted() {
    this.image = 'https://fakeimg.pl/100x100/?retina=1&text=Img&font=noto';
    await this.fetchMember();
    await this.fetchTimeVisitor();
    await this.fetchStarTransaction();
    await this.getProfile();
    this.branch = await this.getByBranchId(this.member.branchId);
    await this.getCommunity();
  }

  async getMemberId() {
    this.memberId = this.memberInitState.component.profileVisit.getMemberId;
    if (!this.memberId) {
      this.Toast({
        message: 'ข้อมูลสมาชิกผิดพลาดกรุณาลองใหม่อีกครั้ง',
        heading: 'ผิดพลาด',
        type: 'danger'
      });
      this.Loading(false);
      throw new Error('ไม่ได้ส่ง member id มา');
    }
    return;
  }

  async getCommunity() {
    if (this.member.branchId !== '') {
      await this.getCommunityForRegister({branchId: this.member.branchId} as FilterCommunity);
      this.communityList = this.communityInitState.community;
      if(this.member.communityId !== '' || this.member.communityId !== null) {
        let com = await this.communityList.find((row) => row.id === this.member.communityId) as Community;
        if(com !== undefined) {
          this.community = com;
        }
      }

    }
  }

  async getProfile() {
    this.getFiles({
      private: true,
      fileType: FileType.original,
      refId: this.member.profile
    }).then((res: any[]) => {
      if (res.length) {
        this.image = res[0].filePath;
      }
    })
  }

  async fetchMember() {
    try {
      this.Loading(true);
      this.getMemberId();
      await this.getMemberById(this.memberId);
      this.member = this.memberInitState.profile;

      console.log(this.member)
      this.Loading(false);
    } catch (e) {
      this.Loading(false);
    }

  }

  traGender(value: string) {
    return value === 'male' ? 'ชาย' : 'หญิง'
  }

  async fetchTimeVisitor() {
    try {
      this.Loading(true);
      this.getMemberId();
      await this.getTimeVisitorInformationById(this.memberId);
      this.timeInformation = this.memberInitState.component.profileVisit.remain;
      this.Loading(false);
    } catch (e) {
      this.Loading(false);
    }
  }

  async fetchStarTransaction() {
    try {
      this.Loading(true);
      this.getMemberId();
      await this.getStarByMemberId(this.memberId);
      this.strRdy = true;
      this.Loading(false);
    } catch (e) {
      this.Loading(false);
    }
  }

  traEducation(text:string) {
    if(text === 'lessThen') {
      return 'ปริญญาตรีหรือต่ำกว่า';
    }else if (text === 'moreThen') {
      return 'สูงกว่าปริญญาตรี';
    }else {
      return '';
    }
  }

}
